/*
 * @Author: wangbaihe
 * @Date: 2024-06-27 16:53:20
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-07-15 17:17:03
 * @FilePath: \common-mediax\src\apis\MediaCloudPublishCenter\Create.js
 * @Description: MediaCloudPublishCenterCreate
 */
import { createAPI } from '@common'

export default {
  // 根据内容，自动提取内容对应的古典美学分类一二级分类项
  postAiExtractCategory: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0dpoufou0fyusbdu0dbufhpsz', 'post', config),
  // 自动提取摘要
  postArticlesSummary: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0ufyuBctusbdu', 'post', { data: config.data }),
  // 自动提取关键词
  postArticlesKeywords: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0lfzxpse', 'post', { data: config.data }),
  // 读列表信息
  getE5Lists: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0f60mjtut',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0f60mjtut', 'get', { params: config.params }, null)
    }
  },
  // 获取栏目树
  getColumns: (config) => {
    if (config.hubConfig) {
      createAPI('customEncryptApiName-1/DNT;0w20dpmvnot0pme',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20dpmvnot0pme',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 栏目检索
  getColumn: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20dpmvno',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20dpmvno', 'get', { params: config.params }, null)
    }
  },
  // 写稿时读出ID、栏目名、操作列表
  getArticlesCreationInitialization: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0nfejby.bsujdmfbqq0bsujdmft0dsfbujpo0jojujbmj{bujpo',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0dsfbujpo0jojujbmj{bujpo',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 读稿件查询列表
  getArticlesList: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20bsujdmft0mjtu',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20bsujdmft0mjtu',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 获取已有相关稿件
  getArticlesRels: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20bsujdmft0sfmt',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20bsujdmft0sfmt',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 保存
  postArticlesCreation: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0nfejby.bsujdmfbqq0bsujdmft0dsfbujpo',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub', ...vconfig }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0dsfbujpo',
        'post',
        { data: config.data },
        vconfig
      )
    }
  },
  // 预览 暂无
  // 签发
  postArticlesIssue: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20bsujdmft0jttvf',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20bsujdmft0jttvf',
        'post',
        { data: config.data },
        null
      )
    }
  },

  // 送审
  postArticlesTransfer: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20bsujdmft0usbotgfs',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub', ...vconfig }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20bsujdmft0usbotgfs',
        'post',
        { data: config.data },
        vconfig
      )
    }
  },
  // 发布
  postArticlesPublish: (config, vconfig) => {
    if (config.hubConfig) {
      createAPI('customEncryptApiName-1/DNT;0nfejby.bsujdmfbqq0bsujdmft0qvcmjti',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub', ...vconfig }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0qvcmjti',
        'post',
        { data: config.data },
        vconfig
      )
    }
  },
  // 获取分组列表接口
  getGroups: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20hspvqt',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20hspvqt', 'get', { params: config.params }, null)
    }
  },
  // 读列表数据
  postE5ListData: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0f60mjtuebub',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0f60mjtuebub', 'post', { data: config.data }, null)
    }
  },
  // 导出列表数据
  postE5ListDataExport: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0f60mjtuebub0fyqpsu',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0f60mjtuebub0fyqpsu',
        'post',
        { data: config.data },
        null
      )
    }
  },
  // 获取图片的数据
  getMamPhotoDetail: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20nbn0qipup0efubjm',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20nbn0qipup0efubjm',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 获取base64Image
  getE5Images: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0f60jnbhft',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub', isHideErrorMessage: true }
      )
    } else {
      return createAPI('customEncryptApiName-1/0f60jnbhft',
        'get',
        { params: config.params },
        { isHideErrorMessage: true }
      )
    }
  },
  // 获取图片base64，不显示loading
  getE5ImagesNoLoading: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0f60jnbhft',
        'get',
        { params: config.params },
        {
          hubForward: true,
          hub: 'e5/hub',
          neverLoading: true,
          isHideErrorMessage: true
        }
      )
    } else {
      return createAPI('customEncryptApiName-1/0f60jnbhft',
        'get',
        { params: config.params },
        { neverLoading: true, isHideErrorMessage: true }
      )
    }
  },
  // 图片裁剪
  postPhotosModifier: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20qipupt0npejgjfs',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20qipupt0npejgjfs',
        'post',
        { data: config.data },
        null
      )
    }
  },
  // 获取分组个数
  getMamGroups: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20nbn0hspvqt',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20nbn0hspvqt', 'get', { params: config.params }, null)
    }
  },
  // 读图片分组下成员
  getMamPhotoMembers: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20nbn0qipup0nfncfst',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20nbn0qipup0nfncfst',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 读图片分组下成员数量
  getMamPhotoMembersCount: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20nbn0qipup0nfncfst0dpvou',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20nbn0qipup0nfncfst0dpvou',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 读视频分组下成员
  getMamVideoMembers: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20nbn0wjefp0nfncfst',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20nbn0wjefp0nfncfst',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 读视频分组下成员数量
  getMamVideoMembersCount: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20nbn0wjefp0nfncfst0dpvou',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20nbn0wjefp0nfncfst0dpvou',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 获取视频的具体信息
  getMamVideoDetail: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20nbn0wjefp0efubjm',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20nbn0wjefp0efubjm',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 获取音频的具体信息
  getMamAudioDetail: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20nbn0bvejp0efubjm',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20nbn0bvejp0efubjm',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 获取水印列表
  getWatermarks: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20xbufsnbslt',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20xbufsnbslt', 'get', { params: config.params }, null)
    }
  },
  // 删除水印
  deleteWatermarks: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20xbufsnbslt',
        'DELETE',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20xbufsnbslt',
        'DELETE',
        { params: config.params },
        null
      )
    }
  },
  // 大数据 文章列表
  postQueryMedia: (config) => {
    let hub = ''
    if (typeof config.hubConfig === 'boolean') {
      hub = config.hubConfig ? '/v1/repository/hub' : '/v1/publishcenter/hub'
    } else {
      switch (config.hubConfig) {
        case 'repository':
          hub = '/v1/repository/hub'
          break
        case 'ClueDig':
          hub = '/v1/newsplan/hub'
          break
        default:
          hub = '/v1/publishcenter/hub'
      }
    }
    return createAPI('customEncryptApiName-1/0bqj0rvfsz0nfejb', 'post', config, {
      hubForward: true,
      hub: hub
    })
  },
  // postQueryMedia: config => createAPI('customEncryptApiName-1/0bqj0rvfsz0nfejb', 'post', config, config.hubConfig ? {hubForward: true, hub: '/v1/repository/hub'} : {hubForward: true, hub: '/v1/publishcenter/hub'}),
  // 大数据 文章详情
  postFtsDocument: (config) => {
    let hub = ''
    // 为了兼容其他模块调用该方法时，传入的config.hubConfig值为布尔类型
    if (typeof config.hubConfig === 'boolean') {
      hub = config.hubConfig ? '/v1/repository/hub' : '/v1/publishcenter/hub'
    } else {
      switch (config.hubConfig) {
        case 'repository':
          hub = '/v1/repository/hub'
          break
        case 'ClueDig':
          hub = '/v1/newsplan/hub'
          break
        default:
          hub = '/v1/publishcenter/hub'
      }
    }
    return createAPI('customEncryptApiName-1/0bqj0gut0epdvnfou', 'post', config, {
      hubForward: true,
      hub: hub
    })
  },
  // postFtsDocument: config => createAPI('customEncryptApiName-1/0bqj0gut0epdvnfou', 'post', config, config.hubConfig ? {hubForward: true, hub: '/v1/repository/hub'} : {hubForward: true, hub: '/v1/publishcenter/hub'}),
  // 读稿件对应的专题栏目信息
  getArticlesSpecialColumn: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tqfdjbm0dpmvno', 'get', config),
  // 读稿件对应的直播信息
  getArticlesLive: (config) => createAPI('customEncryptApiName-1/0w20bsujdmft0mjwf', 'get', config),
  // 保存图片到本地
  postPhotosLocalization: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0qipupt0mpdbmj{bujpo',
      'post',
      { data: config.data },
      config.hubConfig ? { hubForward: true, hub: 'e5/hub' } : null
    ),
  postPhotosLocalizationNoMessage: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0nfejby.sftpvsdf0w20qipupt0mpdbmj{bujpo',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub', isHideErrorMessage: true }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0qipupt0mpdbmj{bujpo',
        'post',
        { data: config.data },
        { isHideErrorMessage: true }
      )
    }
  },
  // 保存转发记录
  postRRMCArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0w20ss0NDBsujdmft0gpsxbse', 'post', config),
  // 稿源库 稿件初始化
  // getRootArticlesCreationInitialization: config => createAPI('customEncryptApiName-1/0w20sppuBsujdmft0dsfbujpo0jojujbmj{bujpo', 'get', config),
  getRootArticlesCreationInitialization: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20sppuBsujdmft0dsfbujpo0jojujbmj{bujpo',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20sppuBsujdmft0dsfbujpo0jojujbmj{bujpo',
        'get',
        { params: config.params },
        null
      )
    }
  },

  // 微信库 稿件初始化
  getWXArticlesCreationInitialization: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0nfejby.bsujdmfxy0xfjyjo0bsujdmft0dsfbujpo0jojujbmj{bujpo',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bsujdmft0dsfbujpo0jojujbmj{bujpo',
        'get',
        { params: config.params }
      )
    }
  },
  // TODO revert
  //  为了高版本云端稿库兼容低版本租户系统，转发时隐藏所有报错：isHideErrorMessage
  // 敏感词检测
  postSensitiveCheck: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20tfotjujwf0difdl', 'post', config, {
        hubForward: true,
        hub: 'e5/hub',
        isHideErrorMessage: true
      })
    } else {
      return createAPI('customEncryptApiName-1/0w20tfotjujwf0difdl', 'post', config, null)
    }
  },
  // 保存至草稿箱
  postArticleDraft: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0nfejby.bsujdmfbqq0bsujdmf0esbgu',
        'post',
        { data: config.data },
        {
          hubForward: true,
          hub: 'e5/hub',
          ...vconfig,
          isSimpleSecurity: true
        }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmf0esbgu',
        'post',
        { data: config.data },
        {
          ...vconfig,
          isSimpleSecurity: true
        }
      )
    }
  },
  // 草稿列表
  getArticleDraft: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20bsujdmf0esbgu',
        'GET',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20bsujdmf0esbgu',
        'GET',
        { params: config.params },
        null
      )
    }
  },
  // 选择草稿,获取草稿详情
  postArticleDraftDetail: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20bsujdmf0esbguEfubjm',
        'GET',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20bsujdmf0esbguEfubjm',
        'GET',
        { params: config.params },
        null
      )
    }
  },
  // 解析word文档
  getArticlesUploadWord: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;w20bsujdmft0vqmpbeXpse', 'GET', config, {
        hubForward: true,
        hub: 'e5/hub'
      })
    } else {
      return createAPI('customEncryptApiName-1/w20bsujdmft0vqmpbeXpse', 'GET', config, null)
    }
  },
  // TODO revert
  //  为了高版本云端稿库兼容低版本租户系统，转发时隐藏所有报错：isHideErrorMessage
  // 检查文章中的媒资库素材是否可用
  postArticlesMamStatus: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;w20bsujdmft0nbn0tubuvt',
        'POST',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub', isHideErrorMessage: true }
      )
    } else {
      return createAPI('customEncryptApiName-1/w20bsujdmft0nbn0tubuvt',
        'POST',
        { data: config.data },
        null
      )
    }
  },
  // 转发进入编辑器获取135样式appkey
  getArticleConfig: (config) => createAPI('customEncryptApiName-1/0w20bsujdmf0dpogjh', 'GET', config),

  // 三方发布--------------------------------------------------
  // 稿件初始化
  getOtherArticlesCreationInitialization: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20puifsBsujdmft0dsfbujpo0jojujbmj{bujpo',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20puifsBsujdmft0dsfbujpo0jojujbmj{bujpo',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 编辑器里左侧图片/视音频列表
  postMamListData: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20nbn0mjtuebub',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20nbn0mjtuebub', 'post', { data: config.data }, null)
    }
  },
  // 以图搜图 获取图片列表
  postMamPhotoSearch: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20nbn0qipup0tfbsdi',
        'post',
        { data: config.data },
        {
          hubForward: true,
          hub: 'e5/hub',
          isHideErrorMessage: true,
          neverLoading: true
        }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20nbn0qipup0tfbsdi',
        'post',
        { data: config.data },
        { isHideErrorMessage: true, neverLoading: true }
      )
    }
  },
  // 文字识别
  getImageOcr: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20bj0jnbhf0pds',
        'GET',
        { params: config.params },
        {
          hubForward: true,
          hub: 'e5/hub',
          isHideErrorMessage: true,
          neverLoading: true
        }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20bj0jnbhf0pds',
        'GET',
        { params: config.params },
        { isHideErrorMessage: true, neverLoading: true }
      )
    }
  },
  // 获取指挥策划列表数据
  postNewsPlanE5ListData: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/OFXTQMBO;0w20tfmfdu0mjtu',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20tfmfdu0mjtu', 'post', { data: config.data }, null)
    }
  },
  // 黑马校对
  postArticlesContentProof: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20bsujdmft0dpoufou0qsppg',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20bsujdmft0dpoufou0qsppg',
        'post',
        { data: config.data },
        null
      )
    }
  },
  // 方正审校
  postArticlesContentFounder: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20bsujdmft0dpoufou0gpvoefsqsppg',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20bsujdmft0dpoufou0gpvoefsqsppg',
        'post',
        { data: config.data },
        null
      )
    }
  },
  // 图文一键转换视频
  postArticleAiNewVideo: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bj0ofxWjefp', 'post', config),
  // 刷新状态
  getArticleAiNewVideoCheck: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bj0ofxWjefp0difdl', 'get', config, {
      neverLoading: true
    }),
  // 是否拥有第三方图片库
  getPhotoOtherPermission: (config) =>
    createAPI('customEncryptApiName-1/0w20qipup0puifs0qfsnjttjpo', 'GET', config),
  // 图片库分组
  getPhotoOtherGroup: (config) =>
    createAPI('customEncryptApiName-1/0w20qipup0puifs0hspvq', 'GET', config),
  // 图片库列表
  postPhotoOtherList: (config) =>
    createAPI('customEncryptApiName-1/0w20qipup0puifs0mjtu', 'POST', config),
  getAdminE5ListData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0f60mjtuebub', 'POST', config),
  // AI导读-根据内容生成AI导读
  getAIGuideByContent: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0w20xpslgmpxt0svo', 'post', config, {
      timeout: 120000
    })
}
